export default {"src":"/_next/static/media/LifecycleManagement.9f21acf4.svg","height":450,"width":714};